export const stateReserveVehicle = {
  open: false,
  veiculoSelecionado: {},
  reserva: {
    observacoes: ''
  }
}

export default {}



// WEBPACK FOOTER //
// ./src/store/reserveVehicle/state.js